import type { LiveChatMode } from '@/features/live/ablySessionChannels';
import type { EvergreenChatMode } from '@/features/webinar/types';

export type ChatWriteAccessContext = {
  /** Mode du chat du live en cours. */
  chatMode?: LiveChatMode;
  /** Mode du chat de l'evergreen, qui rejoue un live avec de vrais modérateurs. */
  evergreenChatMode?: EvergreenChatMode;
  /** Spectateur. Présentateurs et modérateurs arrivent ici avec `isAttendee` faux. */
  isAttendee?: boolean;
};

/** Le présentateur a coupé la parole, en live comme en evergreen. */
export function isChatDisabledMode({
  chatMode,
  evergreenChatMode,
}: ChatWriteAccessContext): boolean {
  return chatMode === 'DISABLED' || evergreenChatMode === 'DISABLED';
}

/**
 * Couper le chat ne ferme l'écriture qu'aux spectateurs : présentateurs et modérateurs continuent
 * de publier, et tout le monde garde la lecture du fil.
 */
export function isAttendeeChatWriteLocked(context: ChatWriteAccessContext): boolean {
  return context.isAttendee === true && isChatDisabledMode(context);
}
